export { default as Thumbnails } from './Thumbnails';
